// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8de6edbe","513":"8d3fd10c","703":"ff891353","787":"cda612ba"}[chunkId] + ".chunk.js";
};